export default {
  ERROR_TITLE: 'Something went wrong:',
  BUTTON_TEXT: 'Try again',
};
